module.exports = __webpack_public_path__ + "static/media/logo2.eaf82acf.png";